import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';
import * as moment from "moment";
// import _ from 'lodash';

export const orderUpdate = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/update', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// for retrying hold payments
export const retryOrderPayment = (id, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post(`order/admin/deliverd/payment?orderId=${id}`, {}, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const updateBOL = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/update-bol', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const getHoldOrdersList = (location, token) => () => {
  return axioPath
    .post('/order/hold/orders', {
      locationId: location
    }, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      return ex;
    });
};

export const downloadCreditMemoApiCall = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/order/resolution/creditmemo?id=' + id, {
      headers: {
        Authorization: `${token}`,
        'Content-Type': "application/octet-stream"
      },
      responseType: 'blob',
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

// for BOL reupload from claim resolving step
export const updateClaimReuploadBOL = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/claim/bol-upload', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const claimDispute = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/claimDispute', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const updatePoNumber = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/update/po-number', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const updateReferenceNumber = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/update/reference-number', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const updateReferenceNumberPTPlus = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/update/order-ref-number', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const orderId = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/order/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const listAllPendingRequestsOrders = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/order/delivery/get_pending_list', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
}

export const listAllOpenOrders = (sortVal, token, searchId, pageNo, filterValues) => (dispatch) => {
  dispatch(showAppLoader());
  if (pageNo === undefined || pageNo === '') pageNo = 1
  if (searchId === undefined) searchId = ''
  let fromDate = searchId.trim() ? null : moment(filterValues.fromDateOrderFilter).format('YYYY-MM-DD')
  let toDate = searchId.trim() ? null : moment(filterValues.toDateOrderFilter).format('YYYY-MM-DD')
  return axioPath
    .get('/order/open/list?timeUnit=MONTH&pageNo=' + pageNo + '&pageSize=10&sort=' + sortVal + '&timeVal=1&search=' + searchId + '&status=' + filterValues.bidStatus + '&deliveryRequirement=' + filterValues.deliveryReq + '&fromDate=' + fromDate + '&toDate=' + toDate, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const listAllDeliveredStatus = (sortVal, token, searchId, pageNo, filterValues) => (dispatch) => {
  dispatch(showAppLoader());
  if (pageNo === undefined || pageNo == '') pageNo = 1
  if (searchId === undefined) searchId = ''
  let fromDate = searchId.trim() ? null : moment(filterValues.fromDateOrderFilter).format('YYYY-MM-DD')
  let toDate = searchId.trim() ? null : moment(filterValues.toDateOrderFilter).format('YYYY-MM-DD')
  return axioPath
    .get('/order/delivered/list?timeUnit=MONTH&timeVal=2&pageNo=' + pageNo + '&pageSize=10&sort=' + sortVal + '&timeVal=1&search=' + searchId + '&status=' + filterValues.bidStatus + '&deliveryRequirement=' + filterValues.deliveryReq + '&fromDate=' + fromDate + '&toDate=' + toDate, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const ratingUpdate = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/rating/update', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const canceledOrder = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/cancel', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const canceledOrderListing = (sortVal, token, searchId, pageNo, filterValues) => (dispatch) => {
  dispatch(showAppLoader());
  if (pageNo === undefined || pageNo == '') pageNo = 1
  if (searchId === undefined) searchId = ''
  let fromDate = searchId.trim() ? null : moment(filterValues.fromDateOrderFilter).format('YYYY-MM-DD')
  let toDate = searchId.trim() ? null : moment(filterValues.toDateOrderFilter).format('YYYY-MM-DD')
  return axioPath
    .get('/order/cancelled/list?timeUnit=MONTH&timeVal=1&pageNo=' + pageNo + '&pageSize=10&sort=' + sortVal + '&timeVal=1&search=' + searchId + '&status=' + filterValues.bidStatus + '&deliveryRequirement=' + filterValues.deliveryReq + '&fromDate=' + fromDate + '&toDate=' + toDate, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const claimedOrderListing = (sortVal, token, searchId, pageNo, filterValues) => (dispatch) => {
  dispatch(showAppLoader());
  if (pageNo === undefined || pageNo == '') pageNo = 1
  if (searchId === undefined) searchId = ''
  let fromDate = searchId.trim() ? null : moment(filterValues.fromDateOrderFilter).format('YYYY-MM-DD')
  let toDate = searchId.trim() ? null : moment(filterValues.toDateOrderFilter).format('YYYY-MM-DD')
  return axioPath
    .get('/order/claim/list?timeUnit=MONTH&timeVal=1&pageNo=' + pageNo + '&pageSize=10&sort=' + sortVal + '&timeVal=1&search=' + searchId + '&status=' + filterValues.bidStatus + '&deliveryRequirement=' + filterValues.deliveryReq + '&fromDate=' + fromDate + '&toDate=' + toDate, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const allOrderListing = (sortVal, token, searchId, pageNo, filterValues) => (dispatch) => {
  dispatch(showAppLoader());
  if (pageNo === undefined || pageNo == '') pageNo = 1
  if (searchId === undefined) searchId = ''
  let fromDate = searchId.trim() ? null : moment(filterValues.fromDateOrderFilter).format('YYYY-MM-DD')
  let toDate = searchId.trim() ? null : moment(filterValues.toDateOrderFilter).format('YYYY-MM-DD')
  return axioPath
    .get('/order/completed/all/list?timeUnit=MONTH&timeVal=1&pageNo=' + pageNo + '&pageSize=10&sort=' + sortVal + '&timeVal=1&search=' + searchId + '&status=' + filterValues.bidStatus + '&deliveryRequirement=' + filterValues.deliveryReq + '&fromDate=' + fromDate + '&toDate=' + toDate, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const downloadOrderById = (id, token, location) => (dispatch) => {
  dispatch(showAppLoader());
  let url = `/order/invoice/download?orderId=${id}`;
  if (location) url += `&locationId=${location}`;
  return axioPath.get(url, {
    headers: {
      Authorization: `${token}`,
      'Content-Type': "application/octet-stream"
    },
    responseType: 'blob',
  }).then((response) => {
    dispatch(hideAppLoader());
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    return ex;
  });
};
export const acceptAndReject = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/scheduled/confirm', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const repostAndScheduledOrder = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/scheduled/repost', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const cancelSellerBuyerOrder = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/cancel/seller-buyer', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const completedOrders = (sortVal, token, searchId, pageNo, filterValues) => (dispatch) => {
  dispatch(showAppLoader());
  if (pageNo === undefined || pageNo == '') pageNo = 1
  if (searchId === undefined) searchId = ''
  let fromDate = searchId.trim() ? null : moment(filterValues.fromDateOrderFilter).format('YYYY-MM-DD')
  let toDate = searchId.trim() ? null : moment(filterValues.toDateOrderFilter).format('YYYY-MM-DD')
  return axioPath
    .get('/order/completed/list?timeUnit=MONTH&pageNo=' + pageNo + '&pageSize=10&sort=' + sortVal + '&timeVal=1&search=' + searchId + '&status=' + filterValues.bidStatus + '&deliveryRequirement=' + filterValues.deliveryReq + '&fromDate=' + fromDate + '&toDate=' + toDate, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const downloadCancelReceiptApi = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/order/invoice/downloadpdf?invoiceId=' + id, {
      headers: {
        Authorization: `${token}`,
        'Content-Type': "application/octet-stream"
      },
      responseType: 'blob',
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const downloadRebateReceipttApi = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/order/resolution/rebate_invoice?invId=' + id, {
      headers: {
        Authorization: `${token}`,
        'Content-Type': "application/octet-stream"
      },
      responseType: 'blob',
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const getUnreadCountApi = (url, token) => () => {
  return axioPath.get(url, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    return ex;
  });
};

export const msgReadAllApi = (url, token) => () => {
  return axioPath.get(url, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    return ex;
  });
};